import React, {createContext, useEffect, useReducer} from 'react'
import MatxLoading from "../../components/MatxLoading";
import useError from "../../hooks/useError";
import SessionOut from "../../views/sessions/SessionOut";
import axios from "./../../../axios"

const initialValue = {
    coupons: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_COUPON_DATA': {
            return {
                ...state,
                coupon_list: action.payload,
            }
        }
        case 'ADD_COUPON_DATA': {
            state.coupon_list.coupons.push(action.payload);

            let newState = {
                coupons: state.coupon_list.coupons
            }

            return {
                ...state,
                coupon_list: newState,
            }
        }
        case 'UPDATE_COUPON_DATA': {
            let newData = state.coupon_list.coupons.map((coupon) =>
                action.payload.id === coupon.id ? action.payload : coupon
            );

            let newState = {
                coupons: newData
            }

            return {
                ...state,
                coupon_list: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const CouponContext = createContext({
    coupon_list: initialValue,
    getCoupons: () => {},
    getCoupon: () => {},
    addCoupons: () => {},
    editCoupons: () => {},
    changeStatus: () => {},
})

export const CouponsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError()

    const getCoupons = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/get_coupons', options);

            dispatch({
                type: 'LOAD_COUPON_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e?.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e?.response?.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e?.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }


    const getCoupon = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            return await axios.get('/api/sales/get_coupon/'+id, options);
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e.response;
        }
    }

    const addCoupons = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sales/add_coupons', data, options);

            dispatch({
                type: 'ADD_COUPON_DATA',
                payload: res.data,
            })
            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e.response;
        }
    }

    const editCoupons = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/sales/edit_coupons', data, options);

            dispatch({
                type: 'UPDATE_COUPON_DATA',
                payload: res.data,
            })
            return res;
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e.response;
        }
    }

    const changeStatus = async (coupon_id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/change_status_coupon/'+coupon_id+"/"+status, options);

            dispatch({
                type: 'UPDATE_COUPON_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            console.error(e)
        }
    }

    useEffect(() => {
        getCoupons();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.status === 401){
        return <SessionOut />
    }

    if(state.coupon_list === undefined) {
        return <MatxLoading />
    }

    return (
        <CouponContext.Provider
            value={{
                coupon_list: state.coupon_list,
                getCoupons,
                getCoupon,
                addCoupons,
                editCoupons,
                changeStatus,
            }}
        >
            {children}
        </CouponContext.Provider>
    )
}

export default CouponContext
